<template>
	<div>
		<div class="row">
			<div class="col-lg-6">
				<label>Nombre *</label>
				<input type="text" class="form-control" v-model="ProyectoDocumento.Nombre"/>
				<Cvalidation v-if="this.errorvalidacion.Nombre" :Mensaje="errorvalidacion.Nombre[0]"></Cvalidation>
			</div>
			<!-- <div class="col-lg-6">
				<label>Dirigido A</label>
				<input type="text" class="form-control" v-model="ProyectoDocumento.DirigidoA"/>
			</div> -->
			<div class="col-lg-6">
				<label>Tipo *</label>
				<select v-model="ProyectoDocumento.Tipo" class="form-control">
					<option value="">-Tipo-</option>
					<option value="1">Personal</option>
					<option value="2">Contratista</option>
					<option value="3">RFI</option>
					<option value="4">Seguridad</option>
				</select>
				<Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="errorvalidacion.Tipo[0]"></Cvalidation>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-4">
				<label>Expedido *</label>
				<v-date-picker v-model="ProyectoDocumento.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
				<Cvalidation v-if="this.errorvalidacion.Fecha" :Mensaje="errorvalidacion.Fecha[0]"></Cvalidation>
			</div>
			<div class="col-lg-8">
				<label>Documento</label>
				<div class="custom-file-input-image">
					<input @change="SubirArchivo()" type="file" accept="application/pdf" ref="documento" class="custom-file-input" id="validatedCustomFile" required>
					<input type="text" v-model="Archivo" class="form-control">
					<button type="button" class=""><i class="fas fa-paperclip"></i></button>
				</div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<label>Comentarios</label>
				<textarea v-model="ProyectoDocumento.Comentarios" class="form-control" cols="30" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"Documento",
    props:["poBtnSave","pIdProyecto"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Documento',
            EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoDocumento:{
				IdProyectoDocumento:0,
				IdProyecto:0,
				Fecha:'',
				Nombre:'',
				DirigidoA:'',
				Comentarios:'',
				Archivo:'',
				Tipo:''
			},
			Archivo:'Elegir Archivo (0.5MB)',
			errorvalidacion:[],
		}
	},
	methods: {
		async Guardar(){
			let Fecha='';
			if (this.ProyectoDocumento.Fecha!='' && this.ProyectoDocumento.Fecha!=undefined) {
                let day=this.ProyectoDocumento.Fecha.getDate();
                let month=this.ProyectoDocumento.Fecha.getMonth()+1;
                let year=this.ProyectoDocumento.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let formData=new FormData();
			formData.set('IdProyectoDocumento',this.ProyectoDocumento.IdProyectoDocumento);
			formData.set('IdProyecto',this.ProyectoDocumento.IdProyecto);
			formData.set('Nombre',this.ProyectoDocumento.Nombre);
			formData.set('DirigidoA',this.ProyectoDocumento.DirigidoA);
			formData.set('Tipo',this.ProyectoDocumento.Tipo);
			formData.set('Comentarios',this.ProyectoDocumento.Comentarios);
			formData.set('Archivo',this.ProyectoDocumento.Archivo);
			formData.set('Fecha',Fecha);
			let image=this.$refs.documento.files[0];
			formData.append('ArchivoFile',image);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			this.$http.post('proyectodocumento/post',formData,{
				headers:{
                    'Content-Type':'multipart/form-data'
                }
			}).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Documento").modal("hide");
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			});
		},
		Limpiar(){
			this.ProyectoDocumento={
				IdProyectoDocumento:0,
				IdProyecto:0,
				Fecha:new Date(),
				Nombre:'',
				Tipo:'',
				DirigidoA:'',
				Comentarios:'',
				Archivo:'',
			};
			this.Archivo='Elegir Archivo (0.5MB)';
			this.errorvalidacion=[];
		},
		Recuperar(){
			this.$http.get('proyectodocumento/recovery',{
                params:{
                    IdProyectoDocumento:this.ProyectoDocumento.IdProyectoDocumento
                }
            }).then((res)=>{
				const objres=res.data.data.proyectodocumento;
				this.ProyectoDocumento.IdProyectoDocumento=objres.IdProyectoDocumento;
				this.ProyectoDocumento.IdProyecto=objres.IdProyecto;
				this.ProyectoDocumento.Nombre=objres.Nombre;
				this.ProyectoDocumento.Tipo=objres.Tipo;
				this.ProyectoDocumento.DirigidoA=objres.DirigidoA;
				this.ProyectoDocumento.Archivo=objres.Archivo;
				this.ProyectoDocumento.Comentarios=objres.Comentarios;
				let formatedDate = objres.Fecha.replace(/-/g, "\/");
				this.ProyectoDocumento.Fecha=new Date(formatedDate);
				this.Archivo=objres.Archivo;
			});
		},
		SubirArchivo(){
			const image = this.$refs.documento.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 0.5 MB');
                const  input  = this.$refs.documento;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.documento;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
            this.poBtnSave.disableBtn=false;
			// console.log(this.pListProyectoReporteObra);
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoDocumento.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoDocumento.IdProyectoDocumento = Id;
				this.Recuperar();
			}
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
